import React from "react";
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import { ElementProps, lightModePalette, typographyProperties } from "../../helpers/constant/themeConstant";

const ThemeLayout = ({ children }) => {
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: lightModePalette,
        typography: typographyProperties,
        components: ElementProps,
      }),
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeLayout;
